module.exports = "/legacy/b22c264480990c39d1a552c662ba13e0.svg";